import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import Icon from '../../../../../components/icon/Icon'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'
import iconsEnum from '../../../../../enums/iconsEnum'
import Button from '../../../../../components/button/Button'
import { useMediaQuery } from 'react-responsive'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	icon: {
		fill: theme.palette.accessibility.main
	},
	divStatus: {
		backgroundColor: theme.palette.accessibility['5'],
		borderRadius: 40,
		width: 172,
		height: 40,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	statusText: {
		marginRight: '4%'
	},
	btnStyleLargeScreen: {
		width: '70%'
	},
	btnStyleSmallScreen: {
		width: '30%'
	}
}))

interface AcceptingProps {
	mttcRestant: number,
	isPartial: boolean,
	isCredit: boolean,
	factureLabel: string,
	pieceNumero: string,
	setOpenPayment: (amount: number, facture: string, piece_numero: string) => void,
	numBail: string,
	paymentDisabled: boolean
}

type StatusOpProps = AcceptingProps

const StatusOP: React.FC<StatusOpProps> = (
	{
		mttcRestant,
		isPartial,
		isCredit,
		factureLabel,
		pieceNumero,
		setOpenPayment,
		paymentDisabled
	}
) => {
	const classes = useStyle()
	const intl = useIntl()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const statusText = classNames(
		classes.colorBlue,
		classes.text4,
		classes.semiBold,
		classes.statusText
	)
	if (isCredit || (Number(mttcRestant) < 1 && Number(mttcRestant) > 0)) {
		return <></>
	} else if (Number(mttcRestant) >= 1) {
		return <div className={isLargeScreen ? classes.btnStyleLargeScreen : classes.btnStyleSmallScreen}>
			<Button
				background="backgroundAccessibility"
				color="colorWhite"
				textStyle="text8"
				disabled={paymentDisabled}
				onClick={() => {
					saveInteractions(
						{
							category: 'Votre Compte',
							action: 'Paiement en Ligne',
							label: 'Payer en ligne Facture'
						}
					)
					setOpenPayment(mttcRestant, factureLabel, pieceNumero)
				}}
				title={intl.formatMessage({
					id: 'contracts.account.payBalanceTitle',
					defaultMessage: 'Le solde de votre compte sera mis à jour 24 heures après votre règlement',
					description: 'Tooltip of the payment button'
				})}
			>
				<FormattedMessage
					id={`contracts.account.payment.partial.btn${isPartial ? 'Partial' : 'Full'}`}
					defaultMessage="Reste à payer"
					description="Payment button"
					values={{ amount: mttcRestant.toLocaleString() }}
				/>
			</Button>
		</div>
	}

	return (
		<div className={classes.divStatus}>
			<span className={statusText}>
				<FormattedMessage
					id="contracts.account.paid"
					defaultMessage="Réglé"
					description="Operation status paid"
				/>
			</span>

			<Icon size={15} icon={iconsEnum.Check} className={classes.icon} />
		</div>
	)
}

export default StatusOP
